import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiSavedReportFormObject } from "../saved-reports-types"
import { omit } from "lodash"

export function useUpdateSavedReportMutation() {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ['update-saved-report'],
    async (savedReport: TApiSavedReportFormObject) => {
      const response = await apiClient.patch(`/saved_reports/${savedReport.id}`, {
        savedReport: omit(savedReport, ['id'])
      })

      if (!response.ok) {
        throw response.errors
      }

      return response.savedReport
    }, {
      // Frontend side active ReactQueries caches update to avoid extra call to the backend with the data at hand
      onSuccess: (data, savedReport) => {
        // Update individual saved report
        queryClient.setQueryData(['saved-reports', savedReport.id], {
          savedReport: data
        })

        // Update in the list if it exists
        const previousSavedReports = queryClient.getQueryData(['saved-reports'])
        if (previousSavedReports) {
          const { savedReports } = previousSavedReports as { savedReports: any[] }
          const updatedReports = savedReports.map(report => 
            report.id === savedReport.id ? data : report
          )
          queryClient.setQueryData(['saved-reports'], { savedReports: updatedReports })
        }
      }
    }
  )

  return mutation
}